import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { AuthService } from './../auth/auth.service';
import { Login } from './../model/login';

@Component({
  templateUrl: 'login.component.html'
})
/** A component to manage login form data input and output. */
export class LoginComponent implements OnInit {

  private readonly _activatedRoute: ActivatedRoute;
  private readonly _authService: AuthService;
  private readonly _router: Router;

  private _redirectUrl: string;

  private code: string;
  private azureerror: string;
  private state: string;
  private sessionstate: string;
  private idtoken: string;

  
  /**
   * Initializes a LoginComponent instance.
   * @param {AuthService}     authService     - An AuthService instance.
   * @param {Router}          router          - A Router instance.
   * @param {Idle}            idle            - An Idle instance.
   * @param {OnErrorService}  onErrorService  - An OnErrorService instance.
   * @param {ActivatedRoute}  activatedRoute  - An activatedRoute instance.
   */
  public constructor(
    authService: AuthService,
    router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    this._authService = authService;
    this._router = router;
    this._activatedRoute = activatedRoute;
    this._redirectUrl = '';
  }

  /** @inheritdoc */
  public ngOnInit() {

    

      var authcokiee = this._authService.getdaappsessionstate();
        console.log(authcokiee);
        let that = this;

        this._activatedRoute.queryParams.subscribe((params: Params) => {

            that.azureerror = params['error'];
            that.code = params['code'];
            that.state = params['state'];
            that.sessionstate = params['session_state'];
            //that.idtoken = params['id_token'];
        });
        console.log("code: " + this.code);
        console.log("state: " + this.state);
        if (this.azureerror != undefined) {
            if (this.azureerror == "access_denied")
            {
               this._router.navigateByUrl('/error?code=access_denied');
                //this._router.navigate(['main','error'], { queryParams: { code: 'access_denied' } });
            }
            else {
              this._router.navigateByUrl('/error?code=error');
               // this._router.navigate(['main','error'], { queryParams: { code: 'error' } });
            }

            //this.router.navigate(['/products'], { queryParams: { order: 'popular' } });
        }
        else {
            if (this.state != undefined && this.code != undefined) {
                if (authcokiee == this.state) {
                    console.log('State Matched');

                    this._authService.getauthuser(this.code, this.sessionstate)
                        .subscribe(
                        result => {
                          if(result != 'FAILED')
                          {
                            console.log(result);
                            var userdata = result;
                            var data = JSON.stringify({ userName: userdata.User_Name, firstName: userdata.First_Name, lastName: userdata.Last_Name, userId: userdata.User_ID });
                            this._authService.setCurrentUser(data);
                            this._authService.settokenid(userdata.TokenId);
                           this._redirectToUrl();
                          }
                          else {
                                //error page
                          }
                        },
                        error => {
                            console.log(error);
                        }
                        
                        );
                }
                else {
                    console.log('State didnt Matched');
                    var token = this.guid();//btoa(Math.random().toString(36));
                    this._authService.setdaappsessionstate(token);
                    this.getazureredirecturl(token);
                }
            }
            else {
                this._authService.clearAllSession();
                var token = this.guid();//btoa(Math.random().toString(36));
                console.log("token: "+ token);
                this._authService.setdaappsessionstate(token);
                this.getazureredirecturl(token);
            }
        }  

  }

  private getazureredirecturl(apptoken: string)
    {
        let that = this;
        let url = '';
        this._authService.getredirecturl(apptoken)
            .subscribe(
            url => {
                console.log(url);
                 window.location.href = url;
            },
            error => {
                console.log(error);
            }
            
            );        
    }

  
  private _redirectToUrl(): void {

    let url = '/app-landing';
    if (this._redirectUrl !== '') {
      url = this._redirectUrl;
    }

    this._router.navigateByUrl(url);
  }


   private rediredtUrl(url) {
        window.location.href = url;
    }

   private  guid() {
        var guid_str = this.s4() + this.s4() + '-' + this.s4() + '-' + this.s4() + '-' +
            this.s4() + '-' + this.s4() + this.s4() + this.s4();
            console.log("guid_str: "+ guid_str)
            return guid_str;
    }

    
   private  s4 () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

  
}
